import React, { Component } from 'react'

import TableHeader from './header'

import LicenseRow from './license-row'

import './license-list.css'
import './table-column-sizes.css'
import axios from 'axios'

class LicenseList extends Component {
    state = {
        reload: false
    }

    toggleLicense(license) {
        license.status = license.status === 'active' ? 'inactive' : 'active'
        axios
            .patch('/license', {
                licenseId: license.licenseId,
                status: license.status
            })
            .then(response => {
                let status = response.data.body.status
                console.log('update license ', status)
                license.status = status
                this.setState({ reload: true })
            })
    }

    render() {
        return (
            <table className="license-list license-list--table">
                <TableHeader
                    onShowEdit={this.props.onShowEdit}
                    sort={this.props.sort}
                    sortOrder={this.props.sortOrder}
                    onSortChange={this.props.onSortChange}
                />
                <tbody>
                    {this.props.licenses.map(license => (
                        <LicenseRow
                            onShowEdit={this.props.onShowEdit}
                            onHistory={this.props.onHistory}
                            key={license.licenseId}
                            license={license}
                            onToggleLicense={() => this.toggleLicense(license)}
                            onEdit={this.props.onEdit}
                            max={this.props.size}
                        />
                    ))}
                    {!this.props.loading && this.props.licenses.length >= this.props.size + this.props.offset && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" onClick={this.props.onLoadMore}>
                                    Load more
                                </button>
                            </td>
                        </tr>
                    )}
                    {this.props.loading && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                    Loading...
                                </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        )
    }
}

export default LicenseList
